/* ────────────────────────────────────────────────────────────
   Pre-built JSON-LD schemas for reuse across pages.
   Separados de SEOHead.tsx porque mezclar un componente con
   exports de constantes en el mismo archivo rompe React Fast
   Refresh (el HMR cae a full-reload en vez de hot-swap).
   ──────────────────────────────────────────────────────────── */

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Ruray Digital',
  url: 'https://ruraydigital.com',
  logo: 'https://ruraydigital.com/ruray-mark-v2.png',
  description: 'CRM con agente de IA en WhatsApp para clínicas dentales en Latinoamérica.',
  foundingDate: '2026',
  founders: [
    { '@type': 'Person', name: 'Ronny Amores' },
    { '@type': 'Person', name: 'Carlos Córdova' },
  ],
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'EC',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+593987119183',
    contactType: 'sales',
    availableLanguage: ['Spanish', 'English', 'Portuguese'],
  },
  sameAs: [
    'https://wa.me/593987119183',
  ],
};

export const PRODUCT_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'RurayHUB',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  description: 'CRM con agente de inteligencia artificial que responde WhatsApp 24/7, agenda citas y envía recordatorios automáticos para clínicas dentales.',
  offers: {
    '@type': 'Offer',
    price: '200',
    priceCurrency: 'USD',
    priceValidUntil: '2027-12-31',
    availability: 'https://schema.org/InStock',
  },
  // aggregateRating quitado a propósito: Google prohíbe ratings no verificables en datos
  // estructurados (self-serving reviews). Volver a agregarlo solo con reseñas reales.
  provider: {
    '@type': 'Organization',
    name: 'Ruray Digital',
  },
};

export const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '¿Necesito saber de tecnología o programación?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Para nada. RurayHUB se configura con clics, no con código. Si sabes usar WhatsApp, sabes usar la plataforma.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Funciona con el número de WhatsApp de mi clínica?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí. Conectas tu número actual sin cambiarlo. Tus pacientes te siguen escribiendo al mismo lugar de siempre.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cuánto tarda en estar listo?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'La mayoría de clínicas quedan operativas el mismo día. Conectar WhatsApp toma minutos y la configuración inicial está lista en menos de una hora.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Qué pasa si un paciente pregunta algo que el agente no sabe?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'El agente deriva la conversación a tu equipo humano sin perder el hilo. Nunca deja a un paciente sin respuesta.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Puedo cancelar cuando quiera?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Claro. No hay contratos de permanencia ni penalizaciones. Te quedas porque funciona, no porque estés amarrado.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Tienen soporte en español?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Totalmente. Somos un equipo regional: soporte en español, en tu zona horaria y que entiende cómo opera tu negocio.',
      },
    },
  ],
};
